import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import { ProducaoService } from '../../../shared/services/api/ProducaoService';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AutoCompleteFazenda01 } from '../../../shared/forms';
import Rproducaofazenda from './Rproducaofazenda';

export const ProducaoFazenda: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataproducao, setDataProducao] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [codfaz, setCodfaz] = useState(0);
  const [nomefaz, setNomefaz] = useState('');
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (   
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;                  
    }          
    setOpenmsg(false);                  
  };                          
              
  const handleProducao = () => {
    ProducaoService                 
      .producaofazenda(dayjs(dataproducao).format('DD/MM/YYYY'), codfaz)   
      .then((result) => {            
        setIsLoading(false);                 
        if (result instanceof Error) {                         
          setTms('error');           
          setMsg(result.message);   
          setOpenmsg(true);                              
        }else {   
          if(result.length > 0){
            Rproducaofazenda(result,  `Fazenda: ${nomefaz}  -  Data Produção: ${dayjs(dataproducao).format('DD/MM/YYYY')}`);  
          }else{
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);  
          }
        }                
      });    
  };

  const handleCodFazenda = (fcodfaz: number | undefined) => {    
    if (fcodfaz != null) {     
      setCodfaz(fcodfaz);                  
    }else{                       
      setCodfaz(0);                         
    }                 
  }; 

  const handleNomeFazenda = (fnome: string | undefined) => {    
    if (fnome != null) {     
      setNomefaz(fnome);                  
    }else{                       
      setNomefaz('');                         
    }                 
  }; 

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' margin={1} alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Relatório de Produção</DialogTitle>
        <DialogContent  dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
           <Grid item>
              <AutoCompleteFazenda01
                isExternalLoading={isLoading}
                codfaz={handleCodFazenda}
                nome={handleNomeFazenda}
              />
           </Grid>
           <Grid marginTop={2} item>
              <LocalizationProvider  dateAdapter={AdapterDayjs}>
                <DatePicker
                  format='DD/MM/YYYY'
                  value={dataproducao}
                  onChange={(newValue) => setDataProducao(newValue)}
                  label='Data Final'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>
           </Grid>         
        </DialogContent>
        <DialogActions>
          <Button variant='contained' autoFocus onClick={handleProducao}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   